import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "68",
      y: "28",
      width: "128",
      height: "12",
      rx: "6",
      fill: "var(--dt-color-surface-moderate)",
      id: "Rectangle 491"
    }, null, -1),
    _createElementVNode("rect", {
      x: "68",
      y: "68",
      width: "101",
      height: "12",
      rx: "6",
      fill: "var(--dt-color-surface-moderate)",
      id: "Rectangle 493"
    }, null, -1),
    _createElementVNode("rect", {
      x: "68",
      y: "48",
      width: "86",
      height: "12",
      rx: "6",
      fill: "var(--dt-color-surface-moderate)",
      id: "Rectangle 492"
    }, null, -1)
  ]))]))
}
export default { render: render }